export default __webpack_public_path__ + "media/color/zrx-9836c6ab.svg";